import { Stack } from '@mui/material';
import { PublishedBook, PublishedBookProps } from './PublishedBook';

type Books = Array<PublishedBookProps>;

const books: Books = [
  {
    name: 'Mastering TypeScript and React Testing with 3TG: A Practical Guide to Writing Robust Tests and Functional Requirements for Modern TypeScript Applications',
    bookUrl: 'https://www.amazon.com/dp/B0FMNY2C53',
    coverUrl: 'https://m.media-amazon.com/images/I/61JlhKUZbuL._SY466_.jpg',
  },
  {
    name: 'Coding Guidelines for React with TypeScript',
    bookUrl: 'https://www.amazon.com/dp/B0DD3DNDY1',
    coverUrl: 'https://m.media-amazon.com/images/I/41C28XMXWeL._SY445_SX342_ControlCacheEqualizer_.jpg',
  },
];

export function PublishedBooks() {
  return (
    <Stack gap={1}>
      {books.map((book) => (
        <PublishedBook key={book.bookUrl} {...book} />
      ))}
    </Stack>
  );
}
